/**
 * GRPS training guides library on SharePoint, filtered to the GRAutomates
 * guides (System = GRAutomates) in the library's own view.
 *
 * One definition for every Help entry point (the ? in the top bar).
 * Opened in a new tab so the reader keeps their place in the app; SharePoint
 * handles its own authentication and access control.
 */
export const TRAINING_GUIDES_URL =
  'https://grpsau.sharepoint.com/GTUT/Training%20Guides/Forms/AllItems.aspx' +
  '?FilterField1=System&FilterValue1=GRAutomates&FilterType1=Choice&FilterDisplay1=GRAutomates' +
  '&viewid=8ca517ac%2D570c%2D481f%2Db8f9%2Ded0cd2808fe9';
